<template>
  <div class="w-100 py-3">
    <div class="mb-4 px-4" v-if="title || description">
      <h3 v-if="title" class="text-center font-weight-bold mb-3">
        {{ title }}
      </h3>
      <p
        v-if="description"
        class="text-justify mb-0"
        style="white-space: pre-line; line-height: 1.8"
      >
        {{ description }}
      </p>
    </div>
    <v-col md="12" style="max-height: 500px; overflow-y: scroll">
      <div style="padding: 5px" v-for="item in value">
        <v-img :src="item.url"></v-img>
      </div>
    </v-col>
  </div>
</template>

<script>
export default {
  name: "verticalCatalog",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
  },
};
</script>

<style scoped></style>
